import type { FC, ReactNode } from 'react';
import type React from 'react';
import { Grid, Stack, Typography } from '@mui/material';

import type { GroupedCodingResult, SentimentCode } from 'src/types/dashboard';

import type { SentimentFilter } from '../types';

import {
  handleSentimentSelection,
  RELEVANCE_ICON_TEST_ID,
} from './SentimentBar';

import { styles } from './index.styles';

interface SentimentTreeLabelProps {
  treeData: GroupedCodingResult;
  sentimentFilter: SentimentFilter;
  handleSelectionClick: (
    topicSentimentId: null | string,
    sentiment?: SentimentCode,
  ) => void;
  handleExpansionClick: (
    event: React.MouseEvent<HTMLDivElement, MouseEvent>,
  ) => void;
  label: ReactNode;
  icon: React.ReactNode;
  labelClasses: string;
}

const SentimentTreeLabel: FC<SentimentTreeLabelProps> = ({
  treeData,
  sentimentFilter,
  label,
  handleSelectionClick,
  handleExpansionClick,
  icon,
  labelClasses,
}) => (
  <Grid item xs={12} md={3} sx={{ display: 'flex', alignItems: 'center' }}>
    {treeData.relevanceRating !== undefined &&
    treeData.relevanceRating >= 0.01 ? (
      <Stack
        sx={styles.medalRelevanceIcon}
        data-test-id={RELEVANCE_ICON_TEST_ID}
      />
    ) : (
      <Stack sx={styles.relevanceIconGap} />
    )}
    <Stack
      direction="column"
      onClick={handleExpansionClick}
      sx={{ cursor: 'pointer', justifyContent: 'center' }}
    >
      {icon}
    </Stack>
    <Stack
      direction="column"
      sx={{
        cursor: 'pointer',
        overflow: 'hidden',
        width: '100%',
        justifyContent: 'center',
      }}
    >
      <Typography
        component="div"
        className={labelClasses}
        onClick={() =>
          handleSentimentSelection(
            sentimentFilter,
            treeData,
            handleSelectionClick,
          )
        }
      >
        {label}
      </Typography>
    </Stack>
  </Grid>
);

export default SentimentTreeLabel;
